export default __webpack_public_path__ + "static/undraw_Choose-cd56f260d79d8f249073d8f3598fed8b.svg";